import React from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';

const Index = () => {
    return (
        <React.Fragment>
            <Routes>
                {/* Public routes — auth gerektirmez */}
                {publicRoutes.map((route, idx) => (
                    <Route
                        path={route.path}
                        element={
                            <NonAuthLayout>
                                {route.component}
                            </NonAuthLayout>
                        }
                        key={`pub-${idx}`}
                        exact={true}
                    />
                ))}

                {/* Auth korumalı routes */}
                {authProtectedRoutes.map((route, idx) => (
                    <Route
                        path={route.path}
                        element={
                            // <AuthProtected>
                            // #185: the route hands over its own roles; AuthProtected no longer matches paths.
                            // WAS (until #307): <AuthProtected roles={route.roles}>
                            // #307: plus who the page is for (side) and an optional permission key.
                            // #311: plus the company-portal module the page belongs to.
                            <AuthProtected roles={route.roles} side={route.side} permission={route.permission}
                                           modul={route.modul} modulMin={route.modulMin} alan={route.alan}>
                                <VerticalLayout>{route.component}</VerticalLayout>
                            </AuthProtected>}
                        key={`auth-${idx}`}
                        exact={true}
                    />
                ))}

                {/* Wildcard — AuthProtected dışında, döngüyü önler */}
                <Route path="*" element={<Navigate to="/Dashboard" replace />} />
            </Routes>
        </React.Fragment>
    );
};

export default Index;
